export default __webpack_public_path__ + "static/media/close-icon-dark.4cb4a60a.svg";